(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8970],{

/***/ 16285:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interior",
      function () {
        return __webpack_require__(33690);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ interior; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-seo-virtual-6b4cc26ed7/0/cache/next-seo-npm-5.15.0-4ac654b130-05b0769d9c.zip/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(46099);
// EXTERNAL MODULE: ./src/components/AppLayout/index.tsx + 17 modules
var AppLayout = __webpack_require__(80330);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@display-component-pc-virtual-6110c01128/0/cache/@display-component-pc-npm-6.3.30-beta.7-673eb18fc6-c2fafc8bf4.zip/node_modules/@display-component/pc/dist/display-component-pc.js + 1 modules
var display_component_pc = __webpack_require__(82545);
// EXTERNAL MODULE: ./src/hooks/index.ts + 3 modules
var hooks = __webpack_require__(57258);
// EXTERNAL MODULE: ./src/constants/display-service.ts
var display_service = __webpack_require__(31957);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@frontend-common-sdk-pc-virtual-b45f9ed0b6/0/cache/@frontend-common-sdk-pc-npm-4.4.0-a0c0e369b7-591826531a.zip/node_modules/@frontend-common-sdk/pc/dist/pc.js
var pc = __webpack_require__(72490);
;// CONCATENATED MODULE: ./src/feat-components/InteriorMain/InteriorMain.tsx






var InteriorMain = function(param) {
    var data = param.data;
    var ref = (0,hooks/* useDisplayComponent */.k)(), handleNewLink = ref.handleNewLink, handleAction = ref.handleAction, handleLogin = ref.handleLogin;
    var isAuthenticated = (0,hooks/* useAuthenticated */.b5)().isAuthenticated;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(display_component_pc/* NewDisplayService */.D1, {
                pageIdentificationValue: display_service/* DISPLAY_SERVICE_MAIN_PC_INT */.Ze,
                onHandleClick: handleNewLink,
                onHandleAction: handleAction,
                onRequireLogin: handleLogin,
                isLogin: isAuthenticated,
                data: data,
                isDataRetry: true,
                style: {
                    paddingBottom: "160px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pc/* FloatingGroup */.X8, {
                visibleConsultButton: true
            })
        ]
    });
};
/* harmony default export */ var InteriorMain_InteriorMain = (InteriorMain);

;// CONCATENATED MODULE: ./src/feat-components/InteriorMain/index.tsx



;// CONCATENATED MODULE: ./pages/interior/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var InteriorMainPage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                noindex: "production" !== "production",
                nofollow: "production" !== "production",
                title: "한샘 인테리어 공식몰",
                description: "트렌디한 인테리어, 맞춤 보양, 사는 집도 안전하게! 인테리어 고민이라면 월 7,000건 시공하는 한샘 전문가와 고민 해결하세요. ",
                openGraph: {
                    description: "트렌디한 인테리어, 맞춤 보양, 사는 집도 안전하게! 인테리어 고민이라면 월 7,000건 시공하는 한샘 전문가와 고민 해결하세요."
                }
            }),
            (props === null || props === void 0 ? void 0 : props.data) && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout/* default */.Z, {
                isHeaderBackgroundColor: false,
                channel: "HOMEIDEA",
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(InteriorMain_InteriorMain, _objectSpread({}, props.data))
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var interior = (InteriorMainPage);


/***/ }),

/***/ 31957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fk": function() { return /* binding */ DISPLAY_SERVICE_PC_MAGAZINE; },
/* harmony export */   "Gl": function() { return /* binding */ DISPLAY_SERVICE_MAIN_PC_HF; },
/* harmony export */   "Jr": function() { return /* binding */ isConsultFloatingPageCode; },
/* harmony export */   "Vd": function() { return /* binding */ DISPLAY_SERVICE_PC_CONSTCASE; },
/* harmony export */   "ZR": function() { return /* binding */ DISPLAY_SERVICE_PC_CATEGORY; },
/* harmony export */   "Ze": function() { return /* binding */ DISPLAY_SERVICE_MAIN_PC_INT; }
/* harmony export */ });
/* unused harmony exports DISPLAY_SERVICE_MAIN_PC, DISPLAY_SERVICE_PC_INT_ALL */
var DISPLAY_SERVICE_MAIN_PC = "HANSSEM_MAIN_PC"; // PC 웰컴 페이지
var DISPLAY_SERVICE_MAIN_PC_HF = "HF_MAIN_PC"; // PC 홈퍼니싱 메인
var DISPLAY_SERVICE_MAIN_PC_INT = "INT_MAIN_PC"; // PC 인테리어 메인
var DISPLAY_SERVICE_PC_CATEGORY = "CATEGORY_PC"; // PC 카테고리 페이지
var DISPLAY_SERVICE_PC_CONSTCASE = "INT_CONSTCASE_PC"; // PC 시공사례 페이지
var DISPLAY_SERVICE_PC_MAGAZINE = "INT_MAGAZINE_PC"; // PC 매거진 페이지
/**
 * PC 전체 인테리어 전시페이지 페이지코드.
 * 어드민: 전시 > 페이지 관리(신규) > 인테리어 > PC > 인테리어_전체
 * 접근 경로: /interior/all, /all
 */ var DISPLAY_SERVICE_PC_INT_ALL = "all";
/** 상담신청('무료 견적 상담') 플로팅 노출 대상 페이지코드인지 판정 (대소문자 무시) */ var isConsultFloatingPageCode = function(pageCode) {
    return pageCode.toLowerCase() === DISPLAY_SERVICE_PC_INT_ALL.toLowerCase();
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2741,330,9774,2888,179], function() { return __webpack_exec__(16285); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);